const { WalletStatus } = require('@pando/tms-constants');
const { cloneDeep } = require('lodash');

const mutation = {
  initialReset(state) {
    state.list = [];
    state.filter = {};
    state.filter.page = 1;
    state.hasEmpty = false;
    state.isLoading = false;
    state.selectedUnused = [];
  },

  paginationCheck(state, status) {
    state.isPaginating = status;
  },

  SET_LOADING(state, status) {
    state.isLoading = status;
  },

  SET_PAGE(state, data) {
    state.filter.page = data;
  },

  SET_LIST(state, data) {
    const result = (state.filter.page > 1) ? state.list.concat(data.data) : data.data;
    state.list = result;
    if (data.is_empty_data) {
      state.hasEmpty = true;
    } else {
      state.filter.page += 1;
      state.hasEmpty = false;
    }
  },
  SET_DETAILS(state, data) {
    state.walletDetails = data && data[0];
  },

  REMOVE_ATTACHMENT(state, attachmentId) {
    if (state.walletDetails) {
      const wallet = cloneDeep(state.walletDetails);
      wallet.attachments = wallet.attachments &&
        wallet.attachments.filter(attachment => attachment.id !== attachmentId);
      state.walletDetails = wallet;
    }
  },

  ADD_ATTACHMENT(state, data) {
    const wallet = cloneDeep(state.walletDetails);
    wallet.attachments.push({
      name: data.content_file_name,
      url: data.metadata.location,
      id: data.id,
    });
    state.walletDetails = wallet;
  },

  SET_ATTACHMENTS(state, data) {
    const attachments = [];
    for (let index = 0; index < data.destinations.length; index += 1) {
      const destinationData = data.destinations[index];
      const attachmentData = destinationData.lr_attachment_ids.map(
        attachment => ({
          name: attachment.content_file_name,
          url: attachment.metadata.location,
          id: attachment.id,
        }),
      );
      attachments.push(...attachmentData);
    }
    state.attachments = attachments;
  },
  setSelectedUnused(state, data) {
    state.selectedUnused = data;
  },
  setPermanentUsed(state, data) {
    state.list = state.list.reduce((acc, element) => {
      if (data.includes(element.id)) {
        element.status = 1;
      }
      acc.push(element);
      return acc;
    }, []);
  },
  setWaivedOff(state, data) {
    state.list = state.list.reduce((acc, element) => {
      if (data.includes(element.id)) {
        element.status = 8;
      }
      acc.push(element);
      return acc;
    }, []);
  },
  markGenerated(state, data) {
    state.list = state.list.reduce((acc, element) => {
      if (data.includes(element.id)) {
        element.status = WalletStatus.GENERATED;
      }
      acc.push(element);
      return acc;
    }, []);
  },
  rejectDraft(state, data) {
    state.list = state.list.reduce((acc, element) => {
      if (data.includes(element.id)) {
        element.status = WalletStatus.DRAFT_REJECTED;
      }
      acc.push(element);
      return acc;
    }, []);
  },
  UPDATE_LIST(state, data) {
    const result = state.list.filter(wallet => wallet.id !== data.id);
    state.list = [data, ...result];
  },
};

export default mutation;
